<template>
  <div>
    <div class="main">
      <div class="check-img"></div>
      <p class="text-line1">스마트 TV 이용권한이 없습니다</p>
      <button
        :class="{ focused: focusIndex === 0 }"
        @click="enterKeyProc"
        @mouseover="focusIndex = 0"
        ref="button"
      >
        이용권 구매하기
      </button>
      <button
        :class="{ focused: focusIndex === 1 }"
        @click="enterKeyProc"
        @mouseover="focusIndex = 1"
        ref="button"
      >
        닫기
      </button>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 0,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },
  props: ["type"],
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
        }
      }
    },
  },
  methods: {
    leftKeyProc(keyInput) {
      if (this.focusIndex === 1) {
        this.focusIndex = 0;
      }
    },
    rightKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.focusIndex = 1;
      }
    },
    enterKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.moveToSignUpQrView();
      } else {
        this.exit();
      }
    },
    moveToSignUpQrView() {
      this.$router.replace({
        name: "subscr",
        params: {
          t: new Date().getTime(),
        },
      });
    },
    exit() {
      deviceApi.stopApplication();
    },
  },
  created() {
    // this.$store.dispatch("REQUEST_LOGOUT");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 272px;
  text-align: center;
}
.check-img {
  width: 200px;
  height: 200px;
  background-image: url("~@/assets/ticket-icon.png");
  margin: 0 auto;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 30px 0;
}
.text-line2 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 90px;
  margin-right: 24px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width:0px) and (max-width:1280px){
  .main {
    margin-top: 272px;
    text-align: center;
  }
  .check-img {
    width: 64px;
    height: 64px;
    background-image: url("~@/assets/notion-ic.png");
    background-size: 100% 100%;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1;
    color: #eeeeee;
    margin: 40px 0 48px;
    font-weight: bold;
  }
  .text-line2 {
    font-size: 28px;
    line-height: 1.29;
    color: #888888;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin-top: 0px;
    margin-right: 16px;
    border: none;
    font-weight: bold;
  }
  button.focused {
    border: solid 3px #ffffff;
  }
}
</style>